import { BaseModel } from "@blue-chip/core";

export default class Term extends BaseModel {}
